import type { FaireProductEntity } from "../../entity_types/product";

export const atc_toast_2: FaireProductEntity = {
  token: "atc_toast_2",
  type: "product",
  name: "Masumoto Peach Fruit Spread",
  brandName: "Sqirl",
  imageUrl: "",
  priceDollars: 14.0,
  msrpDollars: 28.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
